import { createContext } from 'react';
import { IDeleteApkFirmwareValidationError, IServerError, IFirmware, TFirmwareType } from 'types';

export type TTypeOfModalWindow = null | 'toConfirmDeleteItem' | 'success' | 'error';
export type TSortBy = '' | 'NameA-Z' | 'NameZ-A' | 'VersionA-Z' | 'VersionZ-A' | 'DescriptionA-Z' | 'DescriptionZ-A';
export type TCountOfItems = '12' | '24' | '48';
export interface IFilterValues {
	searchString: string;
	IDSelectedTypeFirmware: Nullable<TFirmwareType>;
	isUnassignedFirmware: boolean;
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
}

export interface IFirmwareState {
	firmware: IFirmware;
	searchString: string;
	IDSelectedTypeFirmware: Nullable<TFirmwareType>;
	isUnassignedFirmware: boolean;
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	typeOfModalWindow: TTypeOfModalWindow;
	errorResponseData: IServerError<IDeleteApkFirmwareValidationError> | null;
}

export const firmwareInitialState: IFirmwareState = {
	firmware: { count: 0, items: [] },
	searchString: '',
	IDSelectedTypeFirmware: null,
	isUnassignedFirmware: false,
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	typeOfModalWindow: null,
	errorResponseData: null,
};

export interface IFirmwareContext extends IFirmwareState {
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	changeTypeFirmware(value: Nullable<TFirmwareType>): void;
	toggleUnassignedFirmware(): void;
	setSortBy(sortBy: TSortBy): void;
	setCountOfItems(count: TCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	resetSelectedControls(): void;
	setFiltersFromQueryString(value: IFilterValues): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	showErrorModalWithInfo(value: IServerError<IDeleteApkFirmwareValidationError> | null): void;
}

export const FirmwareContext = createContext<IFirmwareContext>({
	deleteSelectedItem: () => undefined,
	changeSearchString: () => undefined,
	changeTypeFirmware: () => undefined,
	toggleUnassignedFirmware: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	resetSelectedControls: () => undefined,
	setFiltersFromQueryString: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	showErrorModalWithInfo: () => undefined,
	...firmwareInitialState,
});
